export const NOTES_ROUTE = '/organizations/notes';
export const ORGANIZATIONS_ROUTE = '/organizations';
export const VIEW_ORG_DETAILS = '/organizations/view/';
